import { Accordion } from '@curology/ui-components-web/react/Accordion';
import { AccordionContent } from '@curology/ui-components-web/react/Accordion/AccordionContent';
import { AccordionSummary } from '@curology/ui-components-web/react/Accordion/AccordionSummary';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useState } from 'react';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

export const IngredientsAccordion = ({
  body,
  title,
}: {
  body: string;
  title: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Accordion className="cur-mt-4">
      <AccordionSummary
        data-sentry-id="Toggle ingredients accordion"
        onClick={() => {
          const newIsOpen = !isOpen;

          setIsOpen(newIsOpen);

          trackEvent(AnalyticsEvent.INGREDIENT_ACCORDION_CLICKED, {
            isOpen: newIsOpen,
          });
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionContent>
        <Typography>{body}</Typography>
      </AccordionContent>
    </Accordion>
  );
};
